<template>
	<VDialogV3
		position="right"
		width="600px"
		title="Добавление услуги"
		:show-submit-button="false"
	>
		<section class="services-list">
			<h1>Услуги</h1>

			<VDataGridActionBarV2>
				<VLink
					@click="$core.dialogs.CreateServiceDialog.show({}, { 'service:created': createService })"
				>
					<template #icon>
						<VIcon material="add"/>
					</template>
					Добавить услугу
				</VLink>
			</VDataGridActionBarV2>

			<VDataGridV2
				layout="fill"
				:loader="dataLoader"
			>
				<VDataGridColumnV2
					id="name"
					label="Наименование услуги"
				/>
				<VDataGridColumnV2
					id="action"
					width="34px"
					content-align="left"
				>
					<template #default="{ row }">
						<VButton
							v-if="!isAdded(row)"
							@click="addServicePosition(row)"
						>
							<template #icon>
								<VIcon material="add"/>
							</template>
						</VButton>
						<VButton
							v-else
							@click="removeServicePosition(row)"
						>
							<template #icon>
								<VIcon material="delete"/>
							</template>
						</VButton>
					</template>
				</VDataGridColumnV2>
			</VDataGridV2>
		</section>

		<VHelperText>
			Если услуги нет в списке, вы можете её
			<VLink
				@click="$core.dialogs.CreateServiceDialog.show({}, { 'service:created': createService })"
			>
				создать
			</VLink>
		</VHelperText>

		<template #footer>
			<VButton @click="$core.dialogs.AddServicePositionDialog.hide()">Закрыть</VButton>
		</template>

	</VDialogV3>
</template>

<script lang="ts">
import VDialogV3        from '@/lib/components/VDialogV3/VDialogV3.vue';
import Shipment         from '@/domains/Shipments/Shipment';
import ShipmentPosition from '@/domains/Shipments/ShipmentPosition';
import Product          from '@/domains/Products/Product';
import ProductsService  from '@/domains/Products/ProductsService';
import DataGridLoader from "@/lib/components/VDataGridV2/DataGridLoader";

export default defineComponent({
	name: 'AddServicePositionDialog',

	components: {
		VDialogV3,
	},

	props: {
		shipment: {
			type:     Shipment,
			required: true,
		},
	},

	data() {
		return {
			addedProductIds: new Set<number>(),
			dataLoader: new DataGridLoader(ProductsService.getListPaginated)
				.useExtraParams({ isService: true }),
		};
	},

	methods: {
		isAdded(product: Product): boolean {
			return this.addedProductIds.has(product.id);
		},

		async createService(name: string): Promise<void> {
			const createResponse = await this.$core.rpc.makeLegacyRequest('products.add', {
				product: {
					name,
					isService:           true,
					isCreatedImplicitly: true,
				},
			});

			if (createResponse.data) {

				const position = this.addServicePosition(createResponse.data);

				if (!position.vatRate) {
					const vatRate          = this.$core.dictionaries.vatRates.find((_rate: any) => _rate.value === 22);
					position.vatRate       = vatRate?.value;
					position.isVatIncluded = true;
				}
			}
			this.dataLoader.refresh();
		},

		addServicePosition(product: Product): ShipmentPosition {
			const position = ShipmentPosition.fromServiceProduct(product, this.shipment);
			this.shipment.addPosition(position);
			this.addedProductIds = new Set([...this.addedProductIds, product.id]);
			return position;
		},

		removeServicePosition(product: Product): void {
			const index = this.shipment.positions.findIndex(
				(pos: any) => pos.product?.id === product.id,
			);

			if (index !== -1) {
				this.shipment.positions.splice(index, 1);
				this.shipment.calculateDependentSums();

				const updated = new Set(this.addedProductIds);
				updated.delete(product.id);
				this.addedProductIds = updated;
			}
		},
	},
});
</script>
